export default "__VITE_ASSET__mwbGUEpU__"